module.exports = require("@swa-ui/core/src/Paginator/Paginator.module.scss");